import React from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Button, Paper, Typography } from '@mui/material';

import useMediaQuery from '../../../../hooks/useMediaQuery';
import { MIN_WIDTH_MD } from '../../../../theme/breakpoints';

import ButtonContainer from '../../../../components/ButtonContainer';
import FileUploader from './FileUploader';
import FileList from './FileList';

import {
  StyledVerticalContent,
  StyledVitoloAdditionalFilesTipContainer,
} from './FileUploader.styled';

export default function UploadOtherTreatmentDocumentVitolo(props) {
  const { selectedDocuments, setSelectedDocuments, nextButtonLink } = props;

  const isDesktop = useMediaQuery(`(min-width: ${MIN_WIDTH_MD})`);

  const validSelectedDocuments = Array.isArray(selectedDocuments)
    ? selectedDocuments.filter((d) => d?.valid)
    : [];

  const history = useHistory();
  const addFileHandler = (currFiles) => {
    setSelectedDocuments((state) => [...state, ...currFiles]);
  };

  const removeFileHandler = (ev, id) => {
    ev?.preventDefault();
    ev?.stopPropagation();

    const updatedFileList = selectedDocuments?.filter((item) => item?.fileId !== id);
    setSelectedDocuments(updatedFileList);
  };

  const nextStepHandler = () => {
    history.push(nextButtonLink);
  };

  const hasFiles = selectedDocuments?.length > 0;

  return (
    <StyledVerticalContent>
      <StyledVitoloAdditionalFilesTipContainer>
        <Typography variant="p">
          <FormattedMessage id="new_claim.upload.page.received_refund" />
        </Typography>
      </StyledVitoloAdditionalFilesTipContainer>

      {!hasFiles && (
        <Typography variant="p">
          <FormattedMessage id="new_claim.upload.page.description" />
        </Typography>
      )}

      {hasFiles && (
        <Paper>
          <FileList files={selectedDocuments} onRemove={removeFileHandler} />
        </Paper>
      )}

      <Paper>
        <FileUploader selectedFiles={selectedDocuments} setSelectedFiles={addFileHandler} />

        {isDesktop && hasFiles && (
          <ButtonContainer>
            <Button
              onClick={nextStepHandler}
              disabled={!validSelectedDocuments.length}
              data-testid="next_button"
            >
              <Typography variant="buttons">
                <FormattedMessage id="common.button.next" />
              </Typography>
            </Button>
          </ButtonContainer>
        )}
      </Paper>

      {!isDesktop && hasFiles && (
        <ButtonContainer>
          <Button
            onClick={nextStepHandler}
            disabled={!validSelectedDocuments.length}
            data-testid="next_button"
          >
            <Typography variant="buttons">
              <FormattedMessage id="common.button.next" />
            </Typography>
          </Button>
        </ButtonContainer>
      )}
    </StyledVerticalContent>
  );
}

UploadOtherTreatmentDocumentVitolo.propTypes = {
  selectedDocuments: PropTypes.arrayOf(
    PropTypes.shape({
      fileId: PropTypes.string,
      valid: PropTypes.bool,
    })
  ),
  setSelectedDocuments: PropTypes.func,
};
